<template>
    <div class="wrapper">
        <page-content></page-content>
    </div>
</template>

<script>
    import PageContent from './parts/Content';

    export default {
        components: {
            PageContent
        }
    };
</script>
